import styled from "styled-components"

export const StyledFoodDetails = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

export const FoodDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  padding: 0 var(--app-horizontal-padding);
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 1000;
`

export const FoodDetailsContent = styled.div`
  height: calc(100% - var(--app-cta-height));
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

export const FoodDetailsInfo = styled.div`
  padding: var(--app-horizontal-padding);
  padding-bottom: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;

  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`
